import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';

const ANIMATION_TIME = 100;

type FadeProps = {
  children: string;
};

export function Fade({ children }: FadeProps) {
  const valueRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    const { current: valueElement } = valueRef;

    if (!valueElement) {
      return;
    }

    if (!valueElement.textContent) {
      valueElement.textContent = children;
      return;
    }

    valueElement.style.opacity = '0';

    const timeout = setTimeout(() => {
      if (!valueElement) {
        return;
      }

      valueElement.textContent = children;
      valueElement.style.opacity = '1';
    }, ANIMATION_TIME);

    return () => {
      clearTimeout(timeout);
    };
  }, [children]);

  return <Value ref={valueRef} />;
}

const Value = styled.span.attrs({
  className: createReadableClass({ component: 'fade', element: 'value' })
})`
  display: block;
  transition: opacity ${ANIMATION_TIME}ms ease-in;
`;
